module.exports = __webpack_public_path__ + "static/media/filip_jicha.313b9ff9.jpg";